import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  FETCH_REGISTRIES,
  LOAD_MORE_REGISTRIES,
  CLEAR_REGISTRIES_FILTERS,
  UPDATE_REGISTRIES_FILTERS,
  SET_REGISTRIES_SORTING
} from './Registries.actions';
import { LOGOUT } from '../../shared/actions/auth.actions';

const initialState = {
  isFetching: true,
  isError: false,
  error: null,
  data: {
    records: [],
    isLast: true,
    hasNext: false,
    hasPrevious: false,
    numberOfElements: 25,
    totalElements: 0,
    totalPages: 0,
  },
  filters: {
    statusList: [],
    factorIdList: [],
    supplierIdList: [],
    debtorIdList: [],
    documentNumber: '',
    documentDate: {
      start: null,
      end: null
    },
    supplyCurrencyCodeISOCDList: [],
    paymentAmount: {
      from: '',
      to: '',
    },
  },
  sorting: {
    direction: '',
    by: '',
  },
};

/** @type {import('redux-persist').PersistConfig} */
const persistConfig = {
  storage,
  key: 'registries-list-cfg',
  whitelist: ['filters', 'sorting'],
};

function RegistriesListReducer(state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_REGISTRIES:
      return {
        ...state,
        isFetching: true,
        isError: false,
        error: null
      };

    case `${FETCH_REGISTRIES}_SUCCESS`:
      return {
        ...state,
        isFetching: false,
        isError: false,
        error: null,
        data: { ...state.data, ...payload.data }
      };

    case `${FETCH_REGISTRIES}_FAIL`:
      return {
        ...state,
        isFetching: false,
        isError: true,
        error: { ...payload }
      };

    case LOAD_MORE_REGISTRIES:
      return {
        ...state,
        isFetching: true,
        isError: false,
        error: null
      };

    case `${LOAD_MORE_REGISTRIES}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload.data,
          records: [
            ...state.data.records,
            ...payload.data.records
          ]
        },
        isFetching: false,
        isError: false,
        error: null
      };

    case `${LOAD_MORE_REGISTRIES}_FAIL`:
      return {
        ...state,
        isFetching: false,
        isError: true,
        error: { ...payload }
      };

    case UPDATE_REGISTRIES_FILTERS:
      return {
        ...state,
        isFetching: false,
        isError: false,
        error: null,
        filters: {
          ...state.filters,
          ...payload
        },
      };

    case CLEAR_REGISTRIES_FILTERS:
      return {
        ...state,
        isFetching: false,
        isError: false,
        error: null,
        filters: payload.type === 'all'
          ? { ...initialState.filters }
          : {
            ...state.filters,
            ...{ [payload.type]: initialState.filters[payload.type] }
          }
      };

    case SET_REGISTRIES_SORTING: {
      return {
        ...state,
        sorting: payload,
      };
    }

    case LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}

export default persistReducer(persistConfig, RegistriesListReducer);
